import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g
      stroke="#fff"
      strokeOpacity={0.85}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
    >
      <path d="M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z" />
      <path d="m7.313 6 1.875 2.25L11.062 6M6.938 10.5h4.5M6.938 8.25h4.5M9.188 8.25v4.5" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" fillOpacity={0.85} d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
